import React from "react";
// noinspection ES6CheckImport
import {Route, Redirect} from "react-router-dom";
import {connect} from 'react-redux';
import {RoleManager} from "./app-config"

function PrivateRoute({component: Component, ...rest}) {
    function isAuthorizedUser() {
        /*
        Allow all roles to access this site
         */
        let isAuthorized = false;
        if (rest.auth.isAuthorized && rest.auth.userData && rest.auth.userData.role.length > 0) {
            rest.auth.userData.role.forEach((currentValue, index, arr) => {
                if (currentValue.code === RoleManager.SA.code ||
                    currentValue.code === RoleManager.Rev.code ||
                    currentValue.code === RoleManager.QTV.code ||
                    currentValue.code === RoleManager.GV.code ||
                    currentValue.code === RoleManager.NV.code ||
                    currentValue.code === RoleManager.GNV.code
                ) {
                    isAuthorized = true;
                    return true;
                }
            });
            return isAuthorized;
        }
        return isAuthorized;

    }

    return (
        <Route
            render={
                function (props) {
                    if (isAuthorizedUser()) {
                        return <Component {...props} />;
                    } else {
                        return <Redirect to="/unauthorized"/>
                    }
                }
            }

            {...rest}
        />
    );
}

function mapState2Props(state) {
    return {
        auth: state.auth
    }
}

export default connect(mapState2Props)(PrivateRoute);
